import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/desktop',
            name: 'admin-desktop',
            component: () => import(/* webpackChunkName: "page-admin-default-desktop" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "桌面"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "桌面"
                            }
                        ]
                    }
                }
            },

        }
    ],
};
